import React, { useState, useEffect, useRef } from "react";
import styles from './index.pcss';
import classNames from "classnames/bind";
import BRTImageModule from "../../atoms/BraRecommendationToolImageGrid";
import { addStep, dressToolInitiateFinalFlag, removeStep, dressToolCloseFlag, startAllSteps, dressToolWithoutFirstStep } from "../../../actions/shared/braRecommendation";
import { connect } from "react-redux";
import { getDressToolStepsData, getDressToolApiCall, getDressToolFlagData } from "../../selectors/braRecommedation";
import Slider from 'react-slick';
import Icon from '../../atoms/Icon';
import {
  hideModal as hideDressToolModal
} from '../../../actions/modal';
import properties from '../../../modules/ajio-util/properties';
import { gtmDressToolInteractEvent,gtmDressToolViewEvent } from "../../../modules/ga/GTMdatalayer";
import { getDressToolAtcPopupConfig } from '../../../refresh/selectors/featureFlagsSelector';
import { replaceWithJioCDN } from "../../../utils/imageHandling";


interface DressTool {
  getApiCallData: any;
  stepData: any;
  addSelectedStyle: (selectedStyle: Array<string>) => void;
  initiateFinalFlag: (finalPageData: Array<FinalPageDataInterface>) => void;
  removeCurrentStyle: () => void;
  triggerFlag: boolean;
  closeFlags: () => void;
  startAllSteps: () => void;
  isDeskTop?: boolean;
  dressToolFlagReducer: any;
  hideATCDressModal?: () => void;
  initiateWithoutFirstFlag: () => void;
  dressToolAtcPopupConfig: any;
}

interface FinalPageDataInterface {
  applicable_style_name: string;
  applicable_style_image_url: string;
  applicable_style_desc: string;
  saas_redirection_params: string;
}

interface EachStepStylesData {
  applicable_styles?: Array<string>;
  style_img_url: string;
  style_name: string;
}

interface EachStepData {
  title: string;
  sub_title: string;
  styles: Array<EachStepStylesData>;
  question_type?:string;
}

const BraRecommendationInitialContainer: React.FC<DressTool> = ({ getApiCallData, stepData, addSelectedStyle, removeCurrentStyle, triggerFlag, initiateFinalFlag, closeFlags, startAllSteps, isDeskTop = false, dressToolFlagReducer, hideATCDressModal, initiateWithoutFirstFlag, dressToolAtcPopupConfig={} }) => {
  const focusableRef = useRef<HTMLDivElement>(null);
  const { initialStepsFlag, skipFirstStep, atcRecommendationStep } = dressToolFlagReducer;
  const startingStep = (skipFirstStep || atcRecommendationStep) ? 1 : 0;
  const [currentStepData, setCurrentStepData] = useState<EachStepData | null>(getApiCallData?.questions?.[startingStep]);                         //current step data
  const [selectedGrid, setSelectedGrid] = useState<number | boolean>(false);
  const [removeButtonSection, setRemoveButtonSection] = useState<boolean>(false);
  const [slickKey, setSlickKey] = useState<number>(0);
  const [gifAnimationTestStart, setGifAnimationTestStart] = useState<boolean>(false);
  const [gifText, setGifText] = useState<string>(getApiCallData && getApiCallData?.result_finding_title);
  const [gifIsTransitioning, setGifIsTransitioning] = useState<boolean>(false);

  const gifProgress = 100;                         //current gif animation is of 2.5 sec
  const cx = classNames.bind(styles);
  let sliderRef = useRef<Slider | null>(null);
  const sliderContainerRef = useRef<HTMLDivElement | null>(null);
  const mobSliderRef = useRef<HTMLDivElement | null>(null);
  let dressToolTriggerPoint = JSON.parse(sessionStorage.getItem('dressToolIngressDetails')) || '';
  const screenLayerType={
    "outfit":"dress tool outfit selection halfcard screen",
    "frontline":"dress tool neckline selection halfcard screen",
    "backline":"dress tool backline selection halfcard screen",
    "neckline":"dress tool neckline selection halfcard screen"
  }


  useEffect(() => {                             //useEffect for gif and gif text sync
    if (!gifAnimationTestStart) return;

    const updateText = () => {
      setGifIsTransitioning(true);
      setTimeout(() => {
        if (gifProgress >= 40 && gifProgress < 41) {
          setGifText("");
        } else if (gifProgress > 42) {
          setGifText(getApiCallData && getApiCallData?.result_found_title ? getApiCallData?.result_found_title :"We've found the perfect bras for you! Choose the styles you'd like to explore");
        }
        setGifIsTransitioning(false);
      }, 900);                             // Half of the total duration because fade-in and out takes other half time
    };

    updateText();
  }, [gifProgress, gifAnimationTestStart]);

  useEffect(() => {
    if(dressToolFlagReducer?.initialStepsFlag || dressToolFlagReducer?.skipFirstStep){
      let currStep = stepData.currentStep + startingStep;                                  //current step tracking
      let data = getApiCallData?.questions?.[currStep];
      if (!triggerFlag) {                                                         //if closed, remove all selected data in 500ms(animation sync)
        setTimeout(() => {
          startAllSteps();
        }, 500);
      }
      else {
        setCurrentStepData(data);
      }
      if (((skipFirstStep || atcRecommendationStep) && stepData.currentStep > 1) || stepData.currentStep > 2) {           //final data processing                                //for final page Initiation(change for homepage)
        const finalData = stepData.perStepData.slice(-2);
        const intersectingStyles = finalData[0].filter((item: string) => finalData.every((subArray: string) => subArray.includes(item)));
        let finalStepData = [];
        for (const key in getApiCallData?.applicable_styles_mapping) {             //intersection Logic
          if (intersectingStyles.includes(key)) {
            finalStepData.push(getApiCallData?.applicable_styles_mapping?.[key]);
          }
        }
        setRemoveButtonSection(true);
        setTimeout(() => {
          initiateFinalFlag(finalStepData);
          setRemoveButtonSection(false);
        }, 2000);
      }
    }
  }, [stepData.currentStep, skipFirstStep, atcRecommendationStep, triggerFlag, dressToolFlagReducer]);

  useEffect(() => {
    if (triggerFlag) {
      document.body.classList.add(cx("body-no-scroll"));
    } else {
      document.body.classList.remove(cx("body-no-scroll"));
    }

    return () => {
      document.body.classList.remove(cx("body-no-scroll"));
    };
  }, [triggerFlag]);

  useEffect(()=>{
    let ga4DressToolFireOnceEvent:string = '';
    const dressToolLocalFlag = localStorage?.getItem('ga4DressToolFireOnce');
    if(dressToolLocalFlag){
      ga4DressToolFireOnceEvent = JSON.parse(dressToolLocalFlag);
    }
    if(currentStepData && currentStepData?.question_type){
      if((ga4DressToolFireOnceEvent && ga4DressToolFireOnceEvent!=currentStepData?.title) || ga4DressToolFireOnceEvent?.length===0){
        gtmDressToolViewEvent('page_view', {screenname: screenLayerType[currentStepData?.question_type],dressToolTriggerPoint:dressToolTriggerPoint?.IngressPoint});
      }
    }
    if (sliderRef.current) {                                //for desktop bringing next level options to left(scrolled to left)
      setSlickKey(prevKey => prevKey + 1);
    }
    if (mobSliderRef.current) {                             //for mobile bringing next level options to left(scrolled to left)
      mobSliderRef.current.scrollTo({
        left: 0,
      });
    }
    if(currentStepData?.styles?.length === undefined){
      setGifAnimationTestStart(true);
    }
    else{
      setGifAnimationTestStart(false);
      setGifText(getApiCallData && getApiCallData?.result_finding_title ? getApiCallData?.result_finding_title : "Finding your perfect match… just a moment!");
    }
    if(currentStepData?.title ){
      localStorage.setItem('ga4DressToolFireOnce', JSON.stringify(currentStepData?.title));
    }
    else{
      localStorage.setItem('ga4DressToolFireOnce', JSON.stringify("final_step"));
    }
  }, [currentStepData]);

  useEffect(() => {
  if (!isDeskTop || !sliderContainerRef.current) return;

  const prevArrow = sliderContainerRef.current.querySelector<HTMLButtonElement>('.slick-prev');
  const nextArrow = sliderContainerRef.current.querySelector<HTMLButtonElement>('.slick-next');

  if (prevArrow) {
    prevArrow.setAttribute('aria-hidden', 'true');
    prevArrow.setAttribute('tabIndex', '-1');
  }

  if (nextArrow) {
    nextArrow.setAttribute('aria-hidden', 'true');
    nextArrow.setAttribute('tabIndex', '-1');
  }
}, [slickKey, isDeskTop, selectedGrid]);


  useEffect(() => {
    if (!isDeskTop && focusableRef.current) {
      const focusableElementsSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      const modal = focusableRef.current;
      const focusableElements = modal.querySelectorAll<HTMLElement>(focusableElementsSelector);
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === "Tab") {
          if (e.shiftKey) {
            if (document.activeElement === firstElement) {
              e.preventDefault();
              lastElement.focus();
            }
          } else {
            if (document.activeElement === lastElement) {
              e.preventDefault();
              firstElement.focus();
            }
          }
        }
      };

      document.addEventListener("keydown", handleKeyDown);
      firstElement?.focus();

      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [isDeskTop, currentStepData]);


  function handleSelectionGrid(index: number): void {
    setSelectedGrid(index);
  }


  function nextStepInitiate(index: number): void {                        //for handling going to next step
    if (selectedGrid !== false && selectedGrid !== true && selectedGrid >= 0) {                                         //0 is expected data
      const selectedStyles = currentStepData?.styles[selectedGrid]?.applicable_styles || [];
      addSelectedStyle(selectedStyles);
      const screenActionType={
        "outfit":"outfit_selected",
        "frontline":"neckline selected",
        "backline":"backline selected",
        "neckline":"neckline selected"
      }
      gtmDressToolInteractEvent('dress_size_tool_interaction', {screenname: screenLayerType[currentStepData?.question_type],dressToolTriggerPoint:dressToolTriggerPoint?.IngressPoint, category:"dress size tool interaction", action:screenActionType[currentStepData?.question_type],label:currentStepData?.styles?.[selectedGrid]?.style_name});
      setSelectedGrid(false);
    }
  }

  function prevStepInitiate(index: number): void {                        //for handling going to previous step
    removeCurrentStyle();
    setSelectedGrid(false);
  }

  const iconStyle = {
    fontSize: '22px',
    color: 'white',
    width: '22px'
  };
  const imageBaseUrl: string = properties.getProperty('imageBaseUrl');

  function getSlickSettings() {
    const settings = {
      dots: false,
      arrows: true,
      swipe: false,
      swipeToSlide: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      initialSlide:0
    };
    return settings;
  }

  const slickSettings = getSlickSettings();

  function toolCloseFunctionality(): void {
    closeFlags();
    startAllSteps();
    setSelectedGrid(false);
    localStorage.setItem('ga4DressToolFireOnce', JSON.stringify("end"));
  }

  function backButtonLogic(currentStep: number): void {
    if (isDeskTop && (skipFirstStep || atcRecommendationStep) && currentStep === 0) {
      hideATCDressModal('dress-tool-modal');
      return;
    }
    if ((skipFirstStep || atcRecommendationStep) && currentStep === 0) {                      //when only 2 steps are there and back button clicked on 1st step, close modal
      closeFlags();
      return;
    }
    prevStepInitiate(stepData.currentStep);
  }


  return (
    <div>
      {!isDeskTop && <div className={cx('backdrop', { backdropVisible: triggerFlag })} />}
      <div className={isDeskTop ? '' : cx('BottomSheetContainer', { BottomSheetOpen: triggerFlag })}>

        {atcRecommendationStep && !isDeskTop ? <div className={cx("atcDressToolContainer")}>
          <div
            className={cx("bottomSheetCloseButtonAtc")}
            role="presentation"
            onClick={() => toolCloseFunctionality()}
          >
            <Icon icon="icon-Close-2" styles={iconStyle} ariaLabel="close" />
          </div>
          <div className={cx("atcDressToolTextSection")}>
            <div className={cx("atcDressToolTitle")}>{dressToolAtcPopupConfig && dressToolAtcPopupConfig?.title ? dressToolAtcPopupConfig?.title : "Woah! That’s a great choice!"}</div>
            <div className={cx("atcDressToolSubTitle")}>{dressToolAtcPopupConfig && dressToolAtcPopupConfig?.subTitle ? dressToolAtcPopupConfig?.subTitle : "Need help finding a bra that pairs perfectly with this dress? We are here to help!"}</div>
          </div>
          <div className={cx("atcDressToolInitiatorBanner")}>
            <img
              onClick={() => {initiateWithoutFirstFlag();sessionStorage.setItem('dressToolIngressDetails', JSON.stringify({IngressPoint:'add to cart', BannerName:(dressToolAtcPopupConfig && dressToolAtcPopupConfig?.bannerName ? dressToolAtcPopupConfig?.bannerName : 'add to cart')}));}}
              className={cx("atcDressToolInitiatorBannerImg")}
              src={dressToolAtcPopupConfig && dressToolAtcPopupConfig?.imgUrl ? replaceWithJioCDN(dressToolAtcPopupConfig?.imgUrl) : ""}
              alt="AJIO Bra Genie"
              width="100%"
            />
          </div>
        </div>
          :
          <div className={cx('nonAtcRecommendationStep')}
            ref={focusableRef}
            role={!isDeskTop ? "dialog" : undefined}
            aria-label="Bra Genie"
            aria-modal={!isDeskTop}
          >
            {!isDeskTop && <div
              className={cx("bottomSheetCloseButton")}
              role="button"
              onClick={() => toolCloseFunctionality()}
              aria-label="close"
              tabIndex={0}
            >
              <Icon icon="icon-Close-2" styles={iconStyle} ariaHidden />
            </div>}

          <div {...(isDeskTop && {'role':"radiogroup",'aria-labelledby':"bra-genie-title bra-genie-desc",'aria-describedby':"bra-genie-desc"})}>
            <div className={cx("titleSection")}>
              <div id="bra-genie-title" className={!isDeskTop ? cx("headingPart") : cx("headingPartDesktop")} role="heading" aria-level={2}>{currentStepData?.title}</div>
              <div id="bra-genie-desc" className={!isDeskTop ? cx("subHeadingPart") : cx("subHeadingPartDesktop")}>{currentStepData?.sub_title}</div>
            </div>


            {!isDeskTop ? <div className={cx("selectionGridContainer")} ref={mobSliderRef} role="radiogroup" aria-labelledby="bra-genie-title" aria-describedby="bra-genie-desc" >                                {/* Mobile Component*/}
              {currentStepData?.styles.length ? currentStepData?.styles.map((item, index) => (
                <div key={index} onClick={() => handleSelectionGrid(index)}  role="radio" aria-checked={selectedGrid===index} aria-label={item.style_name}>
                  <BRTImageModule
                    imageLink={item?.style_img_url}
                    imageName={item.style_name}
                    isSelected={selectedGrid === index}
                    inputType="radio"
                  />
                </div>
              ))
                : <div className={cx("waitingData")}>
                  <img className={!isDeskTop ? cx("waitingDataGifMobile"): ""}
                    src={`${imageBaseUrl}/static/img/DressToolLoader.gif`}
                    alt="AJIO Bra Genie gif"
                    width="100%"
                  />
                  <div
                    className={cx("waitingDataText")}
                    style={{
                      transition: `opacity 1000ms ease-in-out`,
                      opacity: gifIsTransitioning ? 0 : 1,
                    }}
                  >
                    {gifText}
                  </div>
                </div>}
            </div>
              :
              <div id="BraDressToolDesktopGrid" ref={sliderContainerRef}>                                {/* Desktop Component*/}
                {currentStepData?.styles.length ? <Slider key={slickKey} ref={sliderRef} {...slickSettings}>
                  {currentStepData?.styles.map((item, index) => (
                    <div key={index} className={cx("sliderDivContainer")} onClick={() => handleSelectionGrid(index)} role="radio" aria-checked={selectedGrid===index}>
                      <BRTImageModule
                        imageLink={item?.style_img_url}
                        imageName={item.style_name}
                        isSelected={selectedGrid === index}
                        isDeskTop={isDeskTop}
                        inputType="radio"
                      />
                    </div>
                  ))
                  }</Slider>
                  : 
                  <div className={cx("waitingData")}>
                  <img className={cx("waitingDataGifMobile")}
                    src={`${imageBaseUrl}/static/img/DressToolLoader.gif`}
                    alt="AJIO Bra Genie gif"
                    width="100%"
                  />
                  <div
                    className={cx("waitingDataTextDesktop")}
                    style={{
                      transition: `opacity 1000ms ease-in-out`,
                      opacity: gifIsTransitioning ? 0 : 1,
                    }}
                  >
                    {gifText}
                  </div>
                </div>}
              </div>
            }
          </div>



            {triggerFlag && !removeButtonSection && <div className={isDeskTop ? cx("buttonSectionDesktop") : cx("buttonSection")}>
              {(stepData.currentStep !== 0 || skipFirstStep || atcRecommendationStep) ? <div className={cx("backButton", { backButtonDesktop: isDeskTop })} onClick={() => backButtonLogic(stepData.currentStep)} role="button" tabIndex={0}>Back</div> : null}          {/*do not show back button on first step (change for homepage)*/}
              <button tabIndex={0} className={cx("nextButton", { nextButtonCover: (stepData.currentStep === 0 && !skipFirstStep && !atcRecommendationStep), [isDeskTop ? 'nextButtonActiveDesktop' : 'nextButtonActive']: selectedGrid !== false, nextButtonDesktop: isDeskTop })} onClick={() => nextStepInitiate(stepData.currentStep)} disabled={selectedGrid !== false ? false : true}>Next</button>
            </div>}

          </div>}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    addSelectedStyle: (selectedStyle: Array<string>) => dispatch(addStep(selectedStyle)),
    removeCurrentStyle: () => dispatch(removeStep()),
    initiateFinalFlag: (finalPageData: Array<FinalPageDataInterface>) => dispatch(dressToolInitiateFinalFlag(finalPageData)),
    closeFlags: () => dispatch(dressToolCloseFlag()),
    startAllSteps: () => dispatch(startAllSteps()),
    hideATCDressModal: name => dispatch(hideDressToolModal(name)),
    initiateWithoutFirstFlag: () => dispatch(dressToolWithoutFirstStep()),
  };
};

const mapStateToProps = (state: any) => {
  return {
    stepData: getDressToolStepsData(state),                               //redux for storing step data for each selected styles
    getApiCallData: getDressToolApiCall(state),
    dressToolFlagReducer: getDressToolFlagData(state),
    dressToolAtcPopupConfig: getDressToolAtcPopupConfig(state)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BraRecommendationInitialContainer);
